import axios from "axios";
import { NotImplementedError } from "../../../errors";
import { PromiseHandler } from "../../../handlers";
import { endOptimizationHoldoutRequestToService, experimentFromService } from "../../../models/experiments";
import { ExperimentBadRequestError } from "../errors";
import { endValidators } from "./validators";
/**
 * Ends a line item's optimization holdout. Its own sub-module because it is a
 * separate endpoint, and `delete(id)` cannot carry both the advertiser and the
 * line item the endpoint needs.
 */
export class ExperimentsHoldoutsEnd extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "experiments.holdouts.end");
        this.validators = endValidators;
        this.url = `${this.sdk.urls.baseAPIUrl}/experiment/optimization-holdout/end`;
    }
    /**
     * Terminates the active optimization holdout experiment on request.lineItemId
     * (scoped to request.advertiserId) and clears the line item's
     * outcomesExperimentDetails. Resolves to the ended experiment.
     * POST /campaign-management/v1/experiment/optimization-holdout/end
     */
    async saveItem(request) {
        const errors = this.validate(request);
        if (errors.size) {
            throw new ExperimentBadRequestError(Array.from(errors.values()).join(", "));
        }
        const body = endOptimizationHoldoutRequestToService(request);
        const ended = await axios
            .post(this.url, body, {
            headers: { "Content-Type": "application/json" }
        })
            .then(({ data: res }) => experimentFromService(res.data));
        this.sdk.experiments.reconcileCache("save", ended);
        // The server cleared the line item's outcomesExperimentDetails, so cached copies are stale.
        this.sdk.campaigns.lineItems.reconcileCache("delete", { id: request.lineItemId });
        this.sdk.caches.clear("campaigns");
        return ended;
    }
    async findItems() {
        throw new NotImplementedError("find — holdouts are read through experiments.find");
    }
    async deleteItem() {
        throw new NotImplementedError("delete");
    }
}
//# sourceMappingURL=end.js.map